import React, { useState, useEffect, useRef, useLayoutEffect, useMemo, createContext, RefObject, useContext } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { CircularProgressCentered } from '../../app/components/sharedcomponents';
import { useAuthProfile } from "../../app/hooks"
import { Alert, Box, Link, Skeleton, Typography } from '@mui/material';
import { AppDispatch, store } from '../../app/store';
import { printError } from '../../app/utils';
import CampaignIcon from '@mui/icons-material/Campaign';
import Stack from '@mui/material/Stack';
import './announcementchannel.css';
import { useNavigate } from "react-router-dom";
import Paper from '@mui/material/Paper';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from 'react-oidc-context';
import { Condition, coonditionContext } from '../..';
import { setOpenChannelReady } from '../../features/dialogSlice';
import { ChatContent, ChatScopeHandle, ChatScopeUseChatMinimal, chatStorageHomePage, commmunityJournalConversationFilter, groupIdGenerator, messageIdGenerator, PATIENT_CONNECT_AI_PROFILE_ID, pollingChatDataService } from './ChatScopeUseChat';
import { ChatMessageContent } from './ChatMessageContent';


const ChatScopeContext = createContext<RefObject<ChatScopeHandle | null> | null>(null);

//let chatService: ChatService | null = null;

export const OpenChannelMain: React.FC<{ channelUrl: string }> = ({ channelUrl }) => {
    const [isInitialized, setInitialized] = useState<boolean>(true)
    const { authStatus, profile: loggedInUserProfile, isLoading: isLoadingLoggedInUserProfile, isSuccess: isSuccessLoggedInUserProfile, isError: isErrorLoggedInUserProfile, error: errorLoggedInUserProfile, } = useAuthProfile()
    const componentRef = useRef<HTMLDivElement>(null);
    const [openChannelEntered, setOpenChannelEntered] = useState<{ isInitialized?: boolean, isLoading?: boolean, isError?: boolean, isSuccess?: boolean, error?: any }>({ isInitialized: false, isLoading: false, isError: false, isSuccess: false })
    const navigate = useNavigate()

    const chatScopeRef = useRef<ChatScopeHandle>(null)

    if (isErrorLoggedInUserProfile) {
        console.error(`Oops - Sorry, Auth Error in Chat ${printError(errorLoggedInUserProfile)} has occurred.  signinSilent?` )
    }

    if (openChannelEntered.isLoading || isLoadingLoggedInUserProfile) {//||  !loggedInUserProfile){
        return (<><CircularProgressCentered /></>)
    }

    return (

        <ChatScopeContext.Provider value={chatScopeRef}>
            <Stack direction="column" gap={2} className='announcement_channel' sx={{ width: '100%', flexGrow: 1, minHeight: 0 }}>
                <Box
                    ref={componentRef}
                    data-base-ui-swipe-ignore
                    sx={{
                        width: '100%',
                        flexGrow: 1,
                        minHeight: 0,
                        overflow: 'hidden',
                    }}
                >

                    {!isInitialized && <Skeleton></Skeleton>}
                    <ChatScopeUseChatMinimal loggedInUserProfile={loggedInUserProfile} ref={chatScopeRef} storage={chatStorageHomePage} conversationFilter={commmunityJournalConversationFilter} >
                        <ChatMessageContent />
                    </ChatScopeUseChatMinimal>
                    <OpenChanneltHeaderMM setInitialized={setInitialized} />
                </Box>
                {authStatus === 'unauthenticated' &&
                    <Link sx={{ mt: 1.5, cursor: 'pointer', textAlign: 'center' }} variant="subtitle2" onClick={() => navigate('/signin')}>
                        Create a free account to use messaging
                    </Link>
                }
            </Stack>
        </ChatScopeContext.Provider>

)

}


export const OpenChanneltHeaderMM: React.FC<{ setInitialized: (isLoading: true) => void }> = ({ setInitialized }) => {
    useEffect(() => {
        setInitialized(true)
    }, [setInitialized])


    return (
        <OpenChatHeaderWithBanner >
            <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>Public Chat & Announcements </Typography>
        </OpenChatHeaderWithBanner>)

}
interface OpenChatHeaderProps {
    children: React.ReactNode; // ReactNode allows passing JSX, strings, numbers, arrays, etc.
}

export const OpenChatHeaderWithBanner: React.FC<OpenChatHeaderProps> = ({ children }) => {

    const [openAnnouncement, setOpenAnnouncement] = useState(false)
    const service = useContext(ChatScopeContext)?.current?.getChatService();
    const lastMessage = service?.getLastActivityMessageForConversation('1', 'announcement')
    const messageText = lastMessage?.content || 'Hello!'
    const messageDate = lastMessage?.createdTime || new Date('2025-11-11')
    const dispatch = useDispatch();


    useLayoutEffect(() => {
        dispatch(setOpenChannelReady(!!service?.getServiceState().isInitialized));
    }, [])

    if (!lastMessage) {
        return null
    }

    return (
        <Box id="banner_container">
            <Paper
                elevation={0}
                sx={{
                    width: '100%',
                    borderRadius: 2,
                    borderLeft: '3px solid #656EFF',
                    backgroundColor: '#F5F3FF',
                    px: 2,
                    py: 1.5,
                }}
            >
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={1}>
                    <Typography id="banner_text" variant="body2" sx={{ fontWeight: 600, color: '#1a1a2e', lineHeight: 1.5, flex: 1 }}>
                        {messageText}
                    </Typography>
                    {messageDate &&
                        <IconButton size="small" onClick={() => setOpenAnnouncement(true)} sx={{ mt: -0.5, mr: -0.5, flexShrink: 0 }}>
                            <OpenInNewIcon sx={{ fontSize: 16, color: '#656EFF' }} />
                        </IconButton>
                    }
                </Stack>
                {messageDate &&
                    <Typography variant="caption" sx={{ color: '#999' }}>
                        {messageDate.toDateString()}
                    </Typography>
                }
            </Paper>
            {messageDate &&
                <Dialog onClose={() => setOpenAnnouncement(false)} open={openAnnouncement}>
                    <DialogTitle>
                        <Stack direction="row" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <CampaignIcon sx={{ color: '#656EFF' }} fontSize='large' />
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Announcement</Typography>
                            <IconButton aria-label="close" onClick={() => setOpenAnnouncement(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                    </DialogTitle>
                    <Paper sx={{ p: 4 }}>
                        <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>{messageDate.toDateString()}</Typography>
                        <Typography variant='subtitle1'>{messageText}</Typography>
                    </Paper>
                </Dialog>
            }
        </Box>
    )
}

export const AnnouncementChannelBanner: React.FC<OpenChatHeaderProps> = ({ children }) => {
    return (
        <Box id="banner_container">
            <OpenChatHeaderWithBanner children={children} />
        </Box>
    )
}


